import ErrorBoundary from 'components/ErrorBoundary'
import React, { useState } from 'react'
import { Card, CardBody, Col, Row } from 'reactstrap'
import Arrow from "assets/icon/Left Chevron.svg";
import { cellRendererCheck, dateFormate } from 'utils/columns';
import ReactStrapTable from 'components/reactStrapTable';
import CrosswalkMapingTable from './CrosswalkMapingTable';
import PendingChargesTable from './pendingChargesTable';
import CellOptions from 'components/reactStrapTable/components/CellOptions';
import { toast } from 'react-toastify';
import Loader from 'components/Loader';

const ChargeCodeMapingTable = (props) => {
  debugger
  const {
    chargecodeflag,
    setChargeCodeflag,
    mapingHistoryData,
    setMapingHistoryData,
    utilizationData,
    setUtilizationData,
    loading,
    orgId,
    setLoading,
    chargeCodeDetails,
    Crosswalkrefetc,
    hidden,
    crosswalksearch,
    tabkey,
    unmappedchargesearch,
    utilizationDataRecords,
    setUtilizationDataRecords,
    purchaseHistoryinstialValues,
    selectedutilizationData,
    setSelectedUtilizationData,
    ishiddenflag,
    setIshiddenflag,
    refetchunMappedcharge,
    storedDate

  } = props
  const [tableData, setTableData] = useState([])
  const handelClickimage = () => {
    setChargeCodeflag(false);
    if (hidden) {
      Crosswalkrefetc(true);
    } else {
      refetchunMappedcharge(true);
    }
  };
 
 
  return (
    <div>
      <Card className="border-0 shadow-top">
        <CardBody className="section-devider-border">
          <ErrorBoundary>
            <Row>
              <div className="d-flex align-items-center">
                <h4
                  className="f-16 text-primary font-weight-700"
                  style={{ cursor: "pointer" }}
                  onClick={handelClickimage}
                >
                  <span
                    style={{
                      paddingRight: "5px",
                      position: "relative",
                      top: "-1px",
                      cursor: "pointer",
                    }}
                  >
                    <img style={{ width: "9px" }} src={Arrow} />
                  </span>{" "}
                  All Charge Codes{" "}
                </h4>
              </div>

              <Col md="3">
                <p className="m-0 f-14 ">Charge Code</p>
                <p className="m-0 f-14 font-weight-500 mt-1">
                  {chargeCodeDetails?.chargeCode}
                </p>
              </Col>
              <Col md="3">
                <p className="m-0 f-14 ">Charge Description</p>
                <p className="m-0 f-14 font-weight-500 mt-1">{chargeCodeDetails?.chargeDescription}</p>
              </Col>
              {hidden == false &&
                <Col md="3">
                  <p className="m-0 f-14 ">Utilization Count</p>
                  <p className="m-0 f-14 font-weight-500 mt-1">

                    {chargeCodeDetails?.unmappedCharges}
                  </p>
                </Col>
              }
            </Row>

          </ErrorBoundary>
        </CardBody>
      </Card>
      {/* {loading && <Loader opacity={0.01} />} */}
      <Card className="border-0 shadow-top my-3">
        <CardBody className="section-devider-border">
          <ErrorBoundary>
            <CrosswalkMapingTable mapingHistoryData={mapingHistoryData}
              setMapingHistoryData={setMapingHistoryData}
              loading={loading}
              Crosswalkrefetc={Crosswalkrefetc}
              orgId={orgId}
              setLoading={setLoading}
              crosswalksearch={crosswalksearch}
              unmappedchargesearch={unmappedchargesearch}
              chargeCodeDetails={chargeCodeDetails}
              tabkey={tabkey}
              setIshiddenflag={setIshiddenflag}
              ishiddenflag={ishiddenflag}
              storedDate={storedDate}

            />
          </ErrorBoundary>
        </CardBody>
      </Card>
      <Card className="border-0 shadow-top my-3" hidden={hidden}>
        <CardBody className="section-devider-border">
          <ErrorBoundary>
            <PendingChargesTable utilizationData={utilizationData}
              setUtilizationData={setUtilizationData}
              loading={loading}
              utilizationDataRecords={utilizationDataRecords}
              orgId={orgId}
              setUtilizationDataRecords={setUtilizationDataRecords}
              purchaseHistoryinstialValues={purchaseHistoryinstialValues}
              setLoading={setLoading}
              selectedutilizationData={selectedutilizationData}
              setSelectedUtilizationData={setSelectedUtilizationData}
            />
          </ErrorBoundary>
        </CardBody>
      </Card>
    </div>
  )
}

export default ChargeCodeMapingTable